module.exports = __webpack_public_path__ + "play/static/media/arrowright.7c1c85a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrowright.svg
// module id = 227
// module chunks = 0